import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types"; // ✅ Add this line
import toast from "react-hot-toast";
import api from "../utils/axiosConfig";
import { jwtDecode } from "jwt-decode";

const UserContext = createContext();

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
};

// ✅ Fixed: persist user between reloads
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setUser(null);
        setIsLoggedIn(false);
        setLoading(false);
        return;
      }

      api
        .get(`/auth/user/${decodedToken.email}`)
        .then((res) => {
          setUser(res.data);
          localStorage.setItem("user", JSON.stringify(res.data));
          setIsLoggedIn(true);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          toast.error(err.response?.data?.message || "Failed to fetch user");
          setLoading(false);
        });
    } catch (err) {
      console.error("JWT decode failed:", err);
      setLoading(false);
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        isLoggedIn,
        loading,
        setUser,
        setIsLoggedIn,
        setLoading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

// ✅ Add PropTypes validation
UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
